import { IAppReducerAction, IAppReducerOwnState } from "../shared/model";

const SET_NOTIFICATION_MESSAGES = "SET_NOTIFICATION_MESSAGES";
const SET_LAST_READ_VERSION = "SET_LAST_READ_VERSION";
const SET_CORE_VERSION = "SET_CORE_VERSION";
const SET_HAS_APP_INSIGHTS_KEY = "SET_HAS_APP_INSIGHTS_KEY";
const SET_SHOW_COOKIE_POLICY_BANNER = "SET_SHOW_COOKIE_POLICY_BANNER"
const SET_FEEDBACKURL = "SET_FEEDBACKURL";

const GET_NOTIFICATION_MESSAGES = "GET_NOTIFICATION_MESSAGES";
const GET_LAST_READ_VERSION = "GET_LAST_READ_VERSION";
const GET_CORE_VERSION = "GET_CORE_VERSION";
const GET_HAS_APP_INSIGHTS_KEY = "GET_HAS_APP_INSIGHTS_KEY";
const GET_SHOW_COOKIE_POLICY_BANNER = "GET_SHOW_COOKIE_POLICY_BANNER";
const GET_FEEDBACKURL = "GET_FEEDBACKURL";

export const initialState: IAppReducerOwnState = {
    notificationMessages: [],
    lastReadVersion: "",
    coreVersion: "",
    hasAppInsightsKey: false,
    showCookiePolicyBanner: false,
    feedbackUrl: ""
};

export function reducer(appState: IAppReducerOwnState, action: IAppReducerAction): IAppReducerOwnState {
    switch (action.type) {
        case SET_NOTIFICATION_MESSAGES:
            return {
                ...appState,
                notificationMessages: action.notificationMessages
            };
        case SET_LAST_READ_VERSION:
            return {
                ...appState,
                lastReadVersion: action.lastReadVersion
            };
        case SET_CORE_VERSION:
            return {
                ...appState,
                coreVersion: action.coreVersion
            };
        case SET_HAS_APP_INSIGHTS_KEY: {
            return {
                ...appState,
                hasAppInsightsKey: action.hasAppInsightsKey
            }
        }
        case SET_SHOW_COOKIE_POLICY_BANNER: {
            return {
                ...appState,
                showCookiePolicyBanner: action.showCookiePolicyBanner
            }
        }
        case SET_FEEDBACKURL: {
            return {
                ...appState,
                feedbackUrl: action.feedbackUrl
            }
        }
        case GET_FEEDBACKURL: {
            return {
                ...appState,
                feedbackUrl: appState.feedbackUrl
            }
        }
        case GET_SHOW_COOKIE_POLICY_BANNER: {
            return {
                ...appState,
                showCookiePolicyBanner: appState.showCookiePolicyBanner
            }
        }
        case GET_HAS_APP_INSIGHTS_KEY: {
            return {
                ...appState,
                hasAppInsightsKey: appState.hasAppInsightsKey
            }
        }
        case GET_CORE_VERSION:
            return {
                ...appState,
                coreVersion: appState.coreVersion
            };
        case GET_NOTIFICATION_MESSAGES:
            return {
                ...appState,
                notificationMessages: appState.notificationMessages
            };
        case GET_LAST_READ_VERSION:
            return {
                ...appState,
                lastReadVersion: appState.lastReadVersion
            };
        default:
            return initialState;
    }
}
